export const BUDGET_QUIZ_FLOW_NAME = 'VENUES_BUDGET_QUIZ';
export const FLOW_VERSION = 1;
